import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StepDto, CreateStep, UpdateStep } from './step-dto';


@Injectable({
  providedIn: 'root'
})
export class GestioneStepService {

  private url = `${environment.apiUrl}/steps`;

  constructor(private http: HttpClient) { }



  getAllByMission(missionId: string): Observable<StepDto[]> {
    return this.http.get<StepDto[]>(`${this.url}/mission/${missionId}`);
  }

  create(data: CreateStep): Observable<StepDto> {
    return this.http.post<StepDto>(`${this.url}`, data);
  }

  read(id: string): Observable<StepDto> {
    return this.http.get<StepDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateStep): Observable<StepDto> {
    return this.http.put<StepDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

}
